import React, { useState, useEffect, useRef } from "react";

const Projects = () => {
  const [visibleProjects, setVisibleProjects] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState('All');
  const sectionRef = useRef(null);

  const projects = [
    {
      id: 1,
      name: "SmartFacebook DApp",
      category: "Blockchain",
      tech: ["Solidity", "Ethereum", "React.js", "ERC-20", "OpenZeppelin"],
      shortDesc: "Decentralized social media platform with token rewards and gamification",
      fullDesc: "A revolutionary decentralized social media platform that leverages blockchain technology to provide users with secure, transparent, and rewarding social networking. Users can create posts, interact with content, and earn RewardTokens through engagement.",
      features: [
        "📝 Post creation with media support",
        "💰 ERC-20 token rewards system", 
        "🎰 Spin-the-wheel gamification",
        "👥 Social interactions (likes, comments, shares)",
        "🔒 Blockchain-based transparency"
      ],
      github: "https://github.com/maneeshmadhusudhanan/FacebookCloneDapp",
      demo: "https://youtu.be/f35PBEUn7q8",
      icon: "📱",
      color: "from-blue-500 to-purple-600",
      status: "Deployed"
    },
    {
      id: 2,
      name: "VehicleBlacklistChain",
      category: "Blockchain",
      tech: ["Hyperledger Fabric", "Go", "Docker", "CouchDB", "MiniFab"],
      shortDesc: "Blockchain-powered solution for immutable vehicle blacklisting and recovery",
      fullDesc: "An enterprise-grade blockchain solution addressing vehicle theft and recovery management through decentralized authority using Hyperledger Fabric with immutable record-keeping.",
      features: [
        "🔐 Role-based access control (MSP)",
        "📜 Complete audit trail with SHA-256",
        "⚡ Real-time event notifications",
        "🏢 Multi-organization support",
        "🔍 CouchDB queryable records"
      ],
      github: "https://github.com/maneeshmadhusudhanan/VehicleBlacklistChain",
      demo: null,
      icon: "🚗",
      color: "from-green-500 to-teal-600",
      status: "Production Ready"
    },
    {
      id: 3,
      name: "CryptoLedger ExchangeDApp",
      category: "DeFi",
      tech: ["Ethereum", "React.js", "Vite", "Tailwind CSS", "JWT", "MetaMask"],
      shortDesc: "Next-gen decentralized crypto exchange with CLX token rewards",
      fullDesc: "A sophisticated decentralized exchange featuring custom CLX tokens, referral systems, developer fees, and gamified trading experiences with secure blockchain transactions.",
      features: [
        "💱 CLX token exchange system",
        "🎁 Referral & rewards program",
        "💰 2% developer fee structure",
        "🎮 Gamified trading experience",
        "🔒 MetaMask & WalletConnect integration"
      ],
      github: "https://github.com/maneeshmadhusudhanan/CryptoLedger-ExchangeDAPP",
      demo: null,
      icon: "💱",
      color: "from-yellow-500 to-orange-600",
      status: "Beta"
    },
    {
      id: 4,
      name: "Smart Certificate DApp",
      category: "Blockchain",
      tech: ["React", "Solidity", "Ethereum", "Alchemy", "Docker"],
      shortDesc: "Blockchain-based certificate verification system",
      fullDesc: "Revolutionary digital certification platform ensuring certificate authenticity through blockchain technology with seamless issuance and verification capabilities.",
      features: [
        "🎓 Digital certificate issuance",
        "🔍 Instant verification system",
        "🔒 Blockchain immutability",
        "🐳 Docker containerization",
        "⚡ Alchemy blockchain integration"
      ],
      github: "https://github.com/maneeshmadhusudhanan/CertiApp-React",
      demo: null,
      icon: "🎓",
      color: "from-purple-500 to-pink-600",
      status: "Active"
    },
    {
      id: 5,
      name: "JobLadder Platform",
      category: "Web Development",
      tech: ["MERN Stack", "JWT", "Tailwind CSS", "Multer", "MongoDB"],
      shortDesc: "Comprehensive job management platform with role-based access",
      fullDesc: "A full-featured job management platform facilitating seamless interactions between Users, Employers, and Admins with comprehensive application tracking and management.",
      features: [
        "👥 Role-based dashboards",
        "🔍 Advanced job search",
        "📋 Application tracking",
        "🔐 JWT authentication",
        "📁 File upload support"
      ],
      github: "https://github.com/maneeshmadhusudhanan/JobLadder",
      demo: null,
      icon: "💼",
      color: "from-indigo-500 to-blue-600",
      status: "Completed"
    },
    {
      id: 6,
      name: "Movie Collection Tracker",
      category: "Mobile Development",
      tech: ["React Native", "Nest.js", "MongoDB", "Tailwind CSS", "JWT"],
      shortDesc: "Next.js-powered movie tracking app for watchlist management",
      fullDesc: "A comprehensive movie tracking application helping users organize their watchlists with detailed movie information and personalized collections.",
      features: [
        "🎬 Movie collection management",
        "📱 Mobile-responsive design",
        "🔎 Advanced search functionality",
        "📜 Personal watchlist creation",
        "🔐 User authentication"
      ],
      github: "https://github.com/ManeeshKBA/Movie-Collection-Tracker",
      demo: null,
      icon: "🎬",
      color: "from-red-500 to-rose-600",
      status: "Live"
    },
    {
      id: 7,
      name: "Weather Forecasting App",
      category: "Web Development",
      tech: ["React.js", "Node.js", "Express", "MongoDB", "Docker"],
      shortDesc: "Global weather forecasting with 7-day predictions",
      fullDesc: "A comprehensive weather application providing current weather details and 7-day forecasts for any city globally with responsive design and user authentication.",
      features: [
        "🌤️ Real-time weather data",
        "📅 7-day forecast",
        "🌍 Global city coverage",
        "📱 Responsive design",
        "🔐 Secure user accounts"
      ],
      github: "https://github.com/maneeshmadhusudhanan/PROJECT_Weather_Forcasting_2024KBA",
      demo: "https://drive.google.com/file/d/18U00nwuL-jeIoXj3N0a_1Q-iJ6GUD2Sm/view?usp=sharing",
      icon: "🌤️",
      color: "from-cyan-500 to-blue-500",
      status: "Deployed"
    }
  ];

  const categories = ['All', 'Blockchain', 'DeFi', 'Web Development', 'Mobile Development'];

  const filteredProjects = selectedCategory === 'All' 
    ? projects 
    : projects.filter(project => project.category === selectedCategory);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          filteredProjects.forEach((_, index) => {
            setTimeout(() => {
              setVisibleProjects(prev => [...prev, index]);
            }, index * 200);
          });
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, [filteredProjects]);

  const ProjectCard = ({ project, index }) => {
    const [isFlipped, setIsFlipped] = useState(false);
    const [isHovered, setIsHovered] = useState(false);

    return (
      <div
        className={`
          project-card transform transition-all duration-700 hover:scale-105
          ${visibleProjects.includes(index) 
            ? 'opacity-100 translate-y-0' 
            : 'opacity-0 translate-y-8'
          }
        `}
        style={{ transitionDelay: `${index * 100}ms` }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <div className="relative h-96 group perspective-1000">
          <div 
            className={`
              relative w-full h-full transition-transform duration-700 transform-style-preserve-3d
              ${isFlipped ? 'rotate-y-180' : ''}
            `}
          >
            {/* Front of card */}
            <div className="absolute inset-0 w-full h-full backface-hidden">
              <div className={`
                h-full bg-gradient-to-br ${project.color} rounded-xl p-6 text-white
                shadow-lg hover:shadow-2xl transition-all duration-300 relative overflow-hidden
              `}>
                {/* Background pattern */}
                <div className="absolute inset-0 opacity-10">
                  <div className="absolute top-0 right-0 w-32 h-32 bg-white rounded-full -translate-y-16 translate-x-16" />
                  <div className="absolute bottom-0 left-0 w-24 h-24 bg-white rounded-full translate-y-12 -translate-x-12" />
                </div>

                {/* Status badge */}
                <div className="absolute top-4 right-4">
                  <span className="px-3 py-1 bg-white bg-opacity-20 rounded-full text-xs font-medium backdrop-blur-sm">
                    {project.status}
                  </span>
                </div>

                {/* Project icon */}
                <div className="text-4xl mb-4 transform transition-transform duration-300 hover:scale-110">
                  {project.icon}
                </div>

                {/* Project info */}
                <h3 className="text-2xl font-bold mb-2">{project.name}</h3>
                <p className="text-sm opacity-90 mb-4">{project.category}</p>
                <p className="text-sm mb-6 leading-relaxed">{project.shortDesc}</p>

                {/* Tech stack */}
                <div className="flex flex-wrap gap-2 mb-6">
                  {project.tech.slice(0, 3).map((tech, i) => (
                    <span 
                      key={i}
                      className="px-2 py-1 bg-white bg-opacity-20 rounded text-xs font-medium backdrop-blur-sm"
                    >
                      {tech}
                    </span>
                  ))}
                  {project.tech.length > 3 && (
                    <span className="px-2 py-1 bg-white bg-opacity-20 rounded text-xs font-medium backdrop-blur-sm">
                      +{project.tech.length - 3} more
                    </span>
                  )}
                </div>

                {/* Flip indicator */}
                <button
                  onClick={() => setIsFlipped(true)}
                  className="absolute bottom-4 left-6 flex items-center space-x-2 text-sm opacity-80 hover:opacity-100 transition-opacity"
                >
                  <span>View Details</span>
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </button>
              </div>
            </div>

            {/* Back of card */}
            <div className="absolute inset-0 w-full h-full backface-hidden rotate-y-180">
              <div className="h-full bg-white rounded-xl p-6 shadow-lg border border-gray-200">
                <button
                  onClick={() => setIsFlipped(false)}
                  className="absolute top-4 right-4 p-2 rounded-full hover:bg-gray-100 transition-colors"
                >
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>

                <h4 className="text-lg font-bold mb-3 text-gray-900">{project.name}</h4>
                <p className="text-sm text-gray-600 mb-4">{project.fullDesc}</p>

                {/* Features */}
                <div className="mb-4">
                  <h5 className="font-semibold text-gray-900 mb-2">Key Features:</h5>
                  <ul className="space-y-1">
                    {project.features.slice(0, 4).map((feature, i) => (
                      <li key={i} className="text-xs text-gray-600">{feature}</li>
                    ))}
                  </ul>
                </div>

                {/* Tech stack full */}
                <div className="mb-4">
                  <h5 className="font-semibold text-gray-900 mb-2">Technologies:</h5>
                  <div className="flex flex-wrap gap-1">
                    {project.tech.map((tech, i) => (
                      <span 
                        key={i}
                        className="px-2 py-1 bg-gray-100 rounded text-xs text-gray-700"
                      >
                        {tech}
                      </span>
                    ))}
                  </div>
                </div>

                {/* Links */}
                <div className="flex space-x-3">
                  <a
                    href={project.github}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center space-x-1 px-3 py-2 bg-gray-900 text-white rounded-lg text-xs hover:bg-gray-800 transition-colors"
                  >
                    <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M10 0C4.477 0 0 4.484 0 10.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0110 4.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.203 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.942.359.31.678.921.678 1.856 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0020 10.017C20 4.484 15.522 0 10 0z" clipRule="evenodd" />
                    </svg>
                    <span>GitHub</span>
                  </a>
                  {project.demo && (
                    <a
                      href={project.demo}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex items-center space-x-1 px-3 py-2 bg-blue-600 text-white rounded-lg text-xs hover:bg-blue-700 transition-colors"
                    >
                      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                      </svg>
                      <span>Demo</span>
                    </a>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <style jsx>{`
        .perspective-1000 {
          perspective: 1000px;
        }
        .transform-style-preserve-3d {
          transform-style: preserve-3d;
        }
        .backface-hidden {
          backface-visibility: hidden;
        }
        .rotate-y-180 {
          transform: rotateY(180deg);
        }
      `}</style>

      <section ref={sectionRef} id="projects" className="py-20 bg-gradient-to-br from-gray-900 via-blue-900 to-purple-900 min-h-screen relative overflow-hidden">
        {/* Animated background */}
        <div className="absolute inset-0">
          <div className="absolute top-20 left-10 w-72 h-72 bg-blue-500 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-blob" />
          <div className="absolute top-40 right-10 w-72 h-72 bg-purple-500 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-blob animation-delay-2000" />
          <div className="absolute -bottom-8 left-20 w-72 h-72 bg-pink-500 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-blob animation-delay-4000" />
        </div>

        <div className="container mx-auto px-4 relative z-10">
          {/* Header */}
          <div className="text-center mb-16">
            <div className="inline-block p-2 bg-gradient-to-r from-blue-600 to-purple-600 rounded-full mb-6">
              <div className="bg-gray-900 rounded-full px-6 py-2">
                <span className="text-sm font-semibold bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent">
                  PORTFOLIO SHOWCASE
                </span>
              </div>
            </div>
            
            <h2 className="text-4xl md:text-6xl font-bold text-white mb-6">
              Featured Projects
            </h2>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed">
              Innovative blockchain solutions and full-stack applications crafted with 
              cutting-edge technologies and best practices.
            </p>

            {/* Category filters */}
            <div className="flex flex-wrap justify-center gap-3 mt-8">
              {categories.map((category) => (
                <button
                  key={category}
                  onClick={() => {
                    setSelectedCategory(category);
                    setVisibleProjects([]);
                  }}
                  className={`
                    px-4 py-2 rounded-full font-medium transition-all duration-300 transform hover:scale-105
                    ${selectedCategory === category
                      ? 'bg-gradient-to-r from-blue-500 to-purple-600 text-white shadow-lg'
                      : 'bg-white bg-opacity-10 text-gray-300 hover:bg-opacity-20'
                    }
                  `}
                >
                  {category}
                </button>
              ))}
            </div>
          </div>

          {/* Projects grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
            {filteredProjects.map((project, index) => (
              <ProjectCard key={project.id} project={project} index={index} />
            ))}
          </div>

          {/* GitHub profile link */}
          <div className="text-center mt-16">
            <a
              href="https://github.com/maneeshmadhusudhanan?tab=repositories"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center space-x-3 px-8 py-4 bg-gradient-to-r from-gray-800 to-gray-900 text-white rounded-full font-semibold hover:from-gray-700 hover:to-gray-800 transition-all duration-300 transform hover:scale-105 shadow-xl"
            >
              <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M10 0C4.477 0 0 4.484 0 10.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0110 4.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.203 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.942.359.31.678.921.678 1.856 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0020 10.017C20 4.484 15.522 0 10 0z" clipRule="evenodd" />
              </svg>
              <span>View All Repositories</span>
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
              </svg>
            </a>
          </div>
        </div>

        <style jsx>{`
          @keyframes blob {
            0% {
              transform: translate(0px, 0px) scale(1);
            }
            33% {
              transform: translate(30px, -50px) scale(1.1);
            }
            66% {
              transform: translate(-20px, 20px) scale(0.9);
            }
            100% {
              transform: translate(0px, 0px) scale(1);
            }
          }
          .animate-blob {
            animation: blob 7s infinite;
          }
          .animation-delay-2000 {
            animation-delay: 2s;
          }
          .animation-delay-4000 {
            animation-delay: 4s;
          }
        `}</style>
      </section>
    </>
  );
};

export default Projects;




// import React from "react";
// import { motion } from "framer-motion";

// const projects = [
//   {
//     title: "VehicleBlacklistChain",
//     tech: "Hyperledger Fabric, Go",
//     desc: "Decentralized vehicle theft reporting and blacklist verification.",
//   },
//   {
//     title: "CryptoLedger Exchange",
//     tech: "Ethereum, React",
//     desc: "DEX with ERC-20 (2% fee), JWT auth, transaction tracking.",
//   },
//   {
//     title: "SmartFacebook DApp",
//     tech: "Ethereum, IPFS",
//     desc: "Decentralized social media with token rewards and IPFS storage.",
//   },
//   {
//     title: "JobLadder",
//     tech: "MERN + Smart Contracts",
//     desc: "Job portal with resume parsing and smart contracts.",
//   },
// ];

// export default function ProjectsParallax() {
//   return (
//     <section id="portfolio" className="relative py-20 bg-slate-900">
//       <div className="absolute inset-0 pointer-events-none bg-[radial-gradient(circle_at_20%_20%,rgba(59,130,246,0.15),transparent_40%),radial-gradient(circle_at_80%_30%,rgba(147,51,234,0.12),transparent_35%)]" />
//       <div className="container relative z-10 mx-auto px-6">
//         <motion.h2
//           initial={{ opacity: 0, y: 20 }}
//           whileInView={{ opacity: 1, y: 0 }}
//           viewport={{ once: true }}
//           className="text-3xl md:text-4xl font-bold text-white mb-10 text-center"
//         >
//           Projects
//         </motion.h2>
//         <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
//           {projects.map((p, i) => (
//             <motion.div
//               key={p.title}
//               initial={{ opacity: 0, y: 16 }}
//               whileInView={{ opacity: 1, y: 0 }}
//               viewport={{ once: true }}
//               whileHover={{ y: -6, scale: 1.02 }}
//               transition={{ duration: 0.25 }}
//               className="glass rounded-2xl p-6 h-full hover:shadow-2xl"
//             >
//               <div className="text-xl font-semibold text-white">{p.title}</div>
//               <div className="text-sm text-blue-300 mt-1">{p.tech}</div>
//               <p className="text-gray-200/90 mt-3">{p.desc}</p>
//             </motion.div>
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// }
